import { render, staticRenderFns } from "./company-navigation.vue?vue&type=template&id=54f444d4"
import script from "./company-navigation.vue?vue&type=script&lang=js"
export * from "./company-navigation.vue?vue&type=script&lang=js"
import style0 from "./company-navigation.vue?vue&type=style&index=0&id=54f444d4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports